import { render, staticRenderFns } from "./EventsExportPage.vue?vue&type=template&id=13fae9ee&"
import script from "./EventsExportPage.vue?vue&type=script&lang=js&"
export * from "./EventsExportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports